<template>
  <div>
    <apexchart
      :loading="ChartLoading"
      type="bar"
      :height="300"
      :options="chartOptions"
      :series="chartSeries"
    />
  </div>
</template>

<script>
const actualYear = new Date().getFullYear();

export default {
  name: "RequestPerDayInAMonthBarChart",
  props: {
    DialoVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    YearSelected: {
      type: Number,
      default: actualYear
    },
    ThecnicianSelected: {
      type: [Number, null]
    },
    CustomerServiceCode: {
      type: [Number, null]
    },
    Month: {
      type: [Number, null]
    },
    ProductId: {
      type: [Number, null]
    },
    ProductName: {
      type: String,
      default: ""
    },
    RequestTypeSelected: {
      type: [Number, null]
    }
  },
  data() {
    return {
      ChartLoading: false,
      chartOptions: {
        chart: {
          height: "50px"
        },
        xaxis: {
          categories: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
            20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
          ]
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: "top" // top, center, bottom
            }
          },
          chart: {
            height: "50px"
          }
        },
        dataLabels: {
          enabled: true,
          // formatter: function (val) {
          //   return val + '%'
          // },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },
        colors: [
          function ({ value /*, seriesIndex, w*/ }) {
            if (value >= 5) {
              return "green";
            } else if (value >= 3) {
              return "yellow";
            } else {
              return "red";
            }
          }
        ]
      },
      chartSeries: [
        {
          name: "Solicitudes por dia",
          data: [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0
          ]
        }
      ]
    };
  },

  mounted() {
    this.getChartData();
  },
  computed: {
    // Computed properties can be added here if needed
    IsDialogVisible() {
      return this.DialoVisible;
    }
  },
  methods: {
    async getChartData() {
      // Fetch or compute the data for the chart and update chartSeries accordingly
      this.ChartLoading = true;

      await this.$http
        .get(
          "api/serviceRequests/GetCountServiceRequestsByProductAndMonthForBarChartAsync",
          {
            params: {
              Id: null,
              ClientCode: null,
              companyCode: "VF",
              Status: null,
              ProductId: this.ProductId,
              month: this.Month,
              year: this.YearSelected,
              responsibleId: this.ThecnicianSelected,
              CustomerService: this.CustomerServiceCode,
              ServiceRequestTypeId: this.RequestTypeSelected
            }
          }
        )
        .then((resp) => {
          this.UpdateChartData(resp.data);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.ChartLoading = false;
        });
    },
    UpdateChartData(newData) {
      let ChartData = {
        Xaxis: [],
        series: []
      };
      for (let i = 1; i <= 31; i++) {
        ChartData.Xaxis.push(i);
        let dayData = newData.find((item) => item.MonthDay === i);
        ChartData.series.push(dayData ? dayData.requestCount : 0);
      }

      this.chartOptions.xaxis.categories = ChartData.Xaxis;

      this.chartSeries = [
        {
          name: "Solicitudes por dia",
          data: ChartData.series
        }
      ];
    }
  },
  watch: {
    IsDialogVisible(newVal) {
      if (newVal) {
        this.getChartData();
      } else {
        // Optionally reset the chart data when the dialog is closed
        this.chartOptions.xaxis.categories = [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
          21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31
        ];
        this.chartSeries = [
          {
            name: "Requests-Per-Day-Empty",
            data: [
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0
            ]
          }
        ];
      }
    }
  }
};
</script>

<style scoped></style>
